import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, setPage, setRowsPerPage } from 'data';
import { selectPage, selectRowsPerPage } from 'data/pagination/selector';

import { useBreathTrainingQuery } from './';

export const useBreathTraining = () => {
  const dispatch = useDispatch<AppDispatch>();

  const page = useSelector(selectPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const {
    dashboardData,
    isLoading: isDashboardLoading,
    updateCommentAsync,
    markImportant,
    isUpdatingComment,
    isMarkingImportant,
    error
  } = useBreathTrainingQuery();

  /* ----------------------------------
   * Pagination handlers
   * ----------------------------------*/
  const handlePageChange = (_event: unknown, newPage: number) => {
    dispatch(setPage(newPage));
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setRowsPerPage(parseInt(event.target.value, 10)));
    dispatch(setPage(0));
  };

  /* ----------------------------------
   * Page loading (NO mutation loading)
   * ------------ ---------------------*/
  const loading = isUpdatingComment || isMarkingImportant ? false : isDashboardLoading;

  return {
    data: dashboardData,
    loading,
    error,

    page,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,

    // mutations
    updateCommentAsync,
    markImportant,

    // mutation loading (separate)
    isUpdatingComment,
    isMarkingImportant
  };
};
